import { ClientProfile, CoachProfile, UserRole } from "@joonapp/web-shared"

import { CoachingGroup } from "../types"

export const isJoonCoach = (profile: CoachProfile | ClientProfile) =>
  profile.user.email?.includes("joonapp") ||
  profile.user.email?.includes("matt200@gmail.com") ||
  profile.user.email?.includes("kbunarjo@berkeley.edu")

export const isJoonCoachingGroup = (coachingGroup: CoachingGroup) => {
  const nonAdminGroupCoaches = coachingGroup.profiles.filter(
    (p) => p.role === UserRole.COACH && p.user.id !== 1458884
  )
  const isJoonCoachProfile = isJoonCoach(nonAdminGroupCoaches[0])
  return isJoonCoachProfile
}
